<template>
  <Footer class="fooo">
    <cell-group v-if="list.length>0" class="formstyle" :border="false">
      <template v-for="item in list">
        <field
          v-if="+item.type === 1"
          v-model="ruleForm[item.key_name]"
          clearable
          :required="item.required == 1"
          @input="changeicon(item,ruleForm[item.key_name])"
          :label="item.show_name"
          :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name"
          :error="icon[item.key_name]==='fail'"
          :type="item.fieldtype?item.fieldtype:'text'"
          autosize
        />

        <field
          v-else-if="+item.type === 2"
          v-model="ruleForm[item.key_name]"
          clearable
          :required="item.required == 1"
          @input="changeicon(item,ruleForm[item.key_name])"
          :label="item.show_name"
          :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name"
          :error="icon[item.key_name]==='fail'"
          type="textarea"
          autosize
        />

        <cell
          :class="{'van-cell--required':+item.required===1,'van-field--error':icon[item.key_name]==='fail'}"
          v-else-if="+item.type===10 || +item.type===5"
        >
          <template slot="label">
            <Upload ref="upload" @setUrl="setUrl" value :keyname="item.key_name" />
          </template>
          <div
            slot="title"
            :style="{color: icon[item.key_name]==='fail'?'red':''}"
          >{{item.placeholder?item.placeholder:'请上传'+item.show_name}}</div>
        </cell>

        <cell
          :class="{'van-cell--required':+item.required===1,'van-field--error':icon[item.key_name]==='fail'}"
          v-else-if="+item.type===11"
        >
          <template slot="label">
            <UploadImage :item="item" @setUrl="setUrl" />
          </template>
          <div
            slot="title"
            :style="{color: icon[item.key_name]==='fail'?'red':''}"
          >{{item.placeholder?item.placeholder:'请上传'+item.show_name}}</div>
        </cell>

        <field
          v-else
          v-model="ruleForm[item.key_name]"
          clearable
          readonly
          :required="item.required == 1"
          :label="item.show_name"
          :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name"
          @click="onOpen(item,ruleForm[item.key_name])"
          right-icon="arrow"
          :error="icon[item.key_name]==='fail'"
        />
        <Icon
          size="16px"
          slot="right-icon"
          v-if="showic[item.key_name]"
          :name="icon[item.key_name]"
          :color="color[item.key_name]"
        />
      </template>
      
    </cell-group>
    <cell-group v-if="list.length>0" class="teamlist" v-for="(row,index) in team">
        <div class="title">
            <div>{{row.name}}</div>
            
            <div class="" v-if="index>0" @click="del(index)">删除</div>
        </div>
        <template  v-for="item in row.item">
          
          <field
            v-if="+item.type === 1"
            v-model="ruleForm[item.key_name]"
            clearable
            :required="item.required == 1"
            @input="changeicon(item,ruleForm[item.key_name])"
            :label="item.show_name"
            :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name"
            :error="icon[item.key_name]==='fail'"
            :type="item.fieldtype?item.fieldtype:'text'"
            autosize
          />

          <field
            v-else-if="+item.type === 2"
            v-model="ruleForm[item.key_name]"
            clearable
            :required="item.required == 1"
            @input="changeicon(item,ruleForm[item.key_name])"
            :label="item.show_name"
            :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name"
            :error="icon[item.key_name]==='fail'"
            type="textarea"
            autosize
          />

          <cell
            :class="{'van-cell--required':+item.required===1,'van-field--error':icon[item.key_name]==='fail'}"
            v-else-if="+item.type===10 || +item.type===5"
          >
            <template slot="label">
              <Upload ref="upload" @setUrl="setUrl" value :keyname="item.key_name" />
            </template>
            <div
              slot="title"
              :style="{color: icon[item.key_name]==='fail'?'red':''}"
            >{{item.placeholder?item.placeholder:'请上传'+item.show_name}}</div>
          </cell>

          <cell
            :class="{'van-cell--required':+item.required===1,'van-field--error':icon[item.key_name]==='fail'}"
            v-else-if="+item.type===11"
          >
            <template slot="label">
              <UploadImage :item="item" @setUrl="setUrl" />
            </template>
            <div
              slot="title"
              :style="{color: icon[item.key_name]==='fail'?'red':''}"
            >{{item.placeholder?item.placeholder:'请上传'+item.show_name}}</div>
          </cell>

          <field
            v-else
            v-model="ruleForm[item.key_name]"
            clearable
            readonly
            :required="item.required == 1"
            :label="item.show_name"
            :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name"
            @click="onOpen(item,ruleForm[item.key_name])"
            right-icon="arrow"
            :error="icon[item.key_name]==='fail'"
          />
          <Icon
            size="16px"
            slot="right-icon"
            v-if="showic[item.key_name]"
            :name="icon[item.key_name]"
            :color="color[item.key_name]"
          />
        </template>
          
      </cell-group>

    <Popup v-model="show" position="bottom" :overlay="true">
      <Picker
        v-if="type==3||type==9"
        show-toolbar
        :columns="options"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
      <Area v-else-if="type==8" :area-list="areaList" @cancel="onCancel" @confirm="onConfirm" />
      <datetime-picker
        v-else
        :min-date="minDate"
        type="date"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </Popup>

    <Popup
      v-model="showstatement"
      closeable
      position="bottom"
      :style="{ height: '100vh',width:'100vw' }"
    >
      <div class="vhtml" v-html="statement"></div>
    </Popup>

    <Cell slot="footbar">
      <div style="display:flex;justify-content: center;margin:.2rem auto;font-size:.2rem;" v-if="statement">
        <Checkbox shape="square" v-model="statementchecked">我已经阅读</Checkbox>
        <span @click="showstatement=true" :style="{color:buttonColor}">免责申明</span>，并同意和遵守申明内容
      </div>
      <div style="display:flex;justify-content: center;">
        <Button
        v-if="team.length"
          round
          type="primary"
          @click="add"
          block
        >新增队员</Button>
        <Button
          round
          type="primary"
          @click="signUp"
          block
          :color="buttonColor"
        >提交信息</Button>
      </div>
      
    </Cell>
  </Footer>
</template>

<script>
import Footer from "../footbar/index";
import Upload from "../Upload/index";
import UploadImage from "../UploadImage/index";
import "./index.less";
import areadeil from "./area.js";
import {
  CellGroup,
  Cell,
  Button,
  Field,
  Picker,
  Popup,
  Area,
  Icon,
  Checkbox,
  DatetimePicker,
} from "vant";

export default {
  name: "Form",
  components: {
    Upload,
    Footer,
    Field,
    CellGroup,
    Cell,
    Button,
    Picker,
    Popup,
    Area,
    Icon,
    Checkbox,
    DatetimePicker,
    UploadImage,
  },
  data() {
    return {
      show: false,
      showstatement: false,
      statementchecked: false,
      checked: false,
      options: [],
      onedata: [],
      ruleForm: {},
      showterm: false,
      icon: {},
      color: {},
      showic: {},
      agree: false,
      type: 0,
      currentDate: false,
      minDate: new Date(1919, 0, 0),
      areaList: areadeil,
      shenfen: true,
    };
  },
  filters: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    team: {
      type: Array,
      default: () => {
        return [];
      },
    },
    buttonColor: String,
    statement: {
      type: String,
      default: "",
    },
  },
  watch: {
    list: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
    team: {
      deep: true,
      handler(val) {
        this.setTeam(val);
      },
    },
  },
  methods: {
    signUp: function (e) {
      let go = true;
      var list = [...this.list]
      if(this.team.length){
        this.team.forEach(row=>{
          list.push.apply(list, row.item)
        })
      }

      list.forEach((value, index) => {
        this.$set(this.showic, value.key_name, true);
        for (let i in this.ruleForm) {
          if (value.key_name == i) {
            if (value.required == 1) {
              value.value = this.ruleForm[i];
              var reg =
                eval(value.rules) == null ? undefined : eval(value.rules);
              var pattern = new RegExp(reg);
              var isshow = pattern.test(value.value);
              var name = isshow == true ? "checked" : "fail";
              var color = isshow == true ? "#57bd6b" : "#ec5351";
              this.$set(this.icon, value.key_name, name);
              this.$set(this.color, value.key_name, color);
            } else {
              value.value = this.ruleForm[i];
              var name = "checked";
              var color = "#57bd6b";
              this.$set(this.icon, value.key_name, name);
              this.$set(this.color, value.key_name, color);
            }
          }
        }
      });
      list.forEach((value, index) => {
        if (!value.value) {
          if (value.required == 1) {
            this.$set(this.icon, value.key_name, "fail");
            this.$set(this.color, value.key_name, "#ec5351");
          } else {
            this.$set(this.icon, value.key_name, "checked");
            this.$set(this.color, value.key_name, "#57bd6b");
          }
        }
      });
      for (let j in this.icon) {
        if (this.icon[j] == "fail") {
          go = false;
        }
      }
      if (go == true) {
        //判断免责声明
        if (
          this.statement !== "" &&
          this.statement != null &&
          !this.statementchecked
        ) {
          this.$dialog
            .alert({
              title: "提示",
              message: "请先同意免责声明",
            })
            .then(() => {
              // on close
            });

          return;
        }
				console.log('----', list)
        this.$emit("submit", list);
      }
    },
    onOpen(e, val) {
      this.onedata = e;
      this.show = true;
      if (e.type == 7) {
        this.type = 7;
      } else if (e.type == 8) {
        this.type = 8;
      } else {
        this.type = e.type;
        this.options = [];
        for (let i = 0, len = e.options.length; i < len; i++) {
          this.options.push(e.options[i].value);
        }
      }
    },
    onCancel(e) {
      this.show = false;
    },
    onConfirm(event, index) {
      if (this.type == 7) {
        event = this.cf.formatTime(event);
      } else if (this.type == 8) {
        event = event[0].name + "," + event[1].name + "," + event[2].name;
      }
      this.$set(this.ruleForm, this.onedata.key_name, event);
      this.changeicon(this.onedata, event);
      this.show = false;
    },
    setUrl: function (res, key) {
      this.$set(this.ruleForm, key, res);
      this.changeicon({ key_name: key }, res);
    },
    changeicon(item, val) {
      this.$set(this.showic, item.key_name, true);
      var reg = eval(item.rules) == null ? undefined : eval(item.rules);
      var pattern = new RegExp(reg);
      var isshow = val == "" ? false : pattern.test(val);
      var name = isshow == true ? "checked" : "fail";
      var color = isshow == true ? "#57bd6b" : "#ec5351";
      this.$set(this.icon, item.key_name, name);
      this.$set(this.color, item.key_name, color);
    },
    setOptions(list) {
      if (this.isterm == false) {
        this.agree = true;
      } else {
        this.agree = false;
      }
      list.forEach((value, index) => {
        if (!!value.value) {
          this.$set(this.ruleForm, value.key_name, value.value);
        }
        if (value.type == 3 || value.type == 9) {
          if (typeof value.options == "string")
            value.options = JSON.parse(value.options);

          if (!!value.value) {
            let selectedvalue = value.options.filter((item) => {
              return item.value == value.value;
            });
            if (selectedvalue.length == 0) {
              this.$set(this.ruleForm, value.key_name, value.options[0].value);
            } else {
              this.$set(this.ruleForm, value.key_name, selectedvalue[0].value);
            }
          } else {
            this.$set(this.ruleForm, value.key_name, value.options[0].value);
          }
        }
      });
    },
    setTeam(list) {
      list.forEach((row)=>{
        row.item.forEach((value, index) => {
          if (!!value.value) {
            this.$set(this.ruleForm, value.key_name, value.value);
          }
          if (value.type == 3 || value.type == 9) {
            if (typeof value.options == "string")
              value.options = JSON.parse(value.options);

            if (!!value.value) {
              let selectedvalue = value.options.filter((item) => {
                return item.value == value.value;
              });
              if (selectedvalue.length == 0) {
                this.$set(this.ruleForm, value.key_name, value.options[0].value);
              } else {
                this.$set(this.ruleForm, value.key_name, selectedvalue[0].value);
              }
            } else {
              this.$set(this.ruleForm, value.key_name, value.options[0].value);
            }
          }
        });
      })
      
    },
    del(index) {
      this.$toast.loading({
        duration: 1000,
        message: '加载中...'
      })
      this.team.splice(index)
      this.setTeam(this.team)
    },
    add() {
      this.$toast.loading({
        duration: 1000,
        message: '加载中...'
      })
      var i = this.team.length + 1
      var item = {
        name: '队员' + i,
        item: [
          {
              "system": "1",
              "key_name": "team_name" + i,
              "show_name": "姓名",
              "type": "1",
              "rules": "",
              "options": "[]",
              "required": 1
          },
          {
              "system": "1",
              "key_name": "team_mobile" + i,
              "show_name": "手机号码",
              "type": "1",
              "rules":"/^1\\d{10}$/",
              "options": "[]",
              "required": 1
          },
          {
              "system": "1",
              "key_name": "team_idtype" + i,
              "show_name": "证件类型",
              "type": "3",
              "rules": "",
              "options": "[{\"key\":0,\"value\":\"\\u8eab\\u4efd\\u8bc1\"},{\"key\":1,\"value\":\"\\u62a4\\u7167\"},{\"key\":2,\"value\":\"\\u6e2f\\u6fb3\\u53f0\\u901a\\u884c\\u8bc1\"}]",
              "required": 1
          },
          {
              "system": "1",
              "key_name": "team_idnumber" + i,
              "show_name": "证件号码",
              "type": "1",
              "rules": "",
              "options": "[]",
              "required": 1
          },   
          {
              "system": "1",
              "key_name": "team_sex" + i,
              "show_name": "性别",
              "type": "3",
              "rules": "",
              "options": "[{\"key\":0,\"value\":\"\\u7537\"},{\"key\":1,\"value\":\"\\u5973\"}]",
              "required": 1
          } 
        ]
      }
      this.team.push(item)
      this.setTeam(this.team)
    }
  },
  mounted() {
    this.setOptions(this.list);
    this.setTeam(this.team)
  },
};
</script>


